/* eslint-disable max-lines */
import { CommonModule, NgClass } from '@angular/common';
import { Component } from '@angular/core';
import {
  BookWidgetFieldInfoTypes,
  BookWidgetFieldUpdateTypes
} from '../../../../constants/book-widget.constants';

import {
  BestFareOptionsMachCoreComponent,
  ConnectionPickerMachCoreComponent,
  DatePickerMachCoreComponent,
  MeetingCodeMachCoreComponent,
  MulticityRoutePickerMachCoreComponent,
  SelectMachCoreComponent
} from '../../../common';

import { DropdownItem } from '@com-delta-omnichannel/mach-core-js';
import { SelectedRange } from '@com-delta-omnichannel/mach/lib/components/organisms/date-picker/models/date-picker.interfaces';
import { BookWidgetFieldUpdateEvent } from '../../../../models/book-widget-fields-update-info.interfaces';
import { HomeBookWidgetBaseComponent } from '../home-book-widget-base/home-book-widget-base.component';

@Component({
  standalone: true,
  selector: 'idp-multi-city-desktop-home',
  templateUrl: './multi-city-desktop-home.component.html',
  imports: [
    CommonModule,
    MulticityRoutePickerMachCoreComponent,
    ConnectionPickerMachCoreComponent,
    DatePickerMachCoreComponent,
    SelectMachCoreComponent,
    BestFareOptionsMachCoreComponent,
    MeetingCodeMachCoreComponent,
    NgClass
  ]
})
export class MulticityDesktopHomeComponent extends HomeBookWidgetBaseComponent {
  infoIconClickHandler(
    sourceIcon: BookWidgetFieldInfoTypes,
    event: Event
  ): void {
    if (sourceIcon) {
      this.handleTooltipAnalytics(sourceIcon, event);
      this.infoIconClick.emit(sourceIcon);
    }
  }

  onDropdownSelectionChange(
    event: DropdownItem,
    bookWidgetFieldUpdateType: BookWidgetFieldUpdateTypes
  ) {
    const emitValue: BookWidgetFieldUpdateEvent = {
      data: event.value,
      type: bookWidgetFieldUpdateType
    };
    this.bookWidgetFieldChange.emit(emitValue);
  }

  onDateSelectionChange(
    event: SelectedRange,
    bookWidgetFieldUpdateType: BookWidgetFieldUpdateTypes,
    index: number
  ) {
    const emitValue: BookWidgetFieldUpdateEvent = {
      data: {
        selectedRange: event,
        flightIndex: index
      },
      type: bookWidgetFieldUpdateType
    };
    this.bookWidgetFieldChange.emit(emitValue);
  }

  onCheckBoxChange(
    event: Event,
    bookWidgetFieldUpdateType: BookWidgetFieldUpdateTypes
  ) {
    const target = event.target as HTMLInputElement;
    const emitValue: BookWidgetFieldUpdateEvent = {
      data: target.checked,
      type: bookWidgetFieldUpdateType
    };
    this.bookWidgetFieldChange.emit(emitValue);
  }

  onInputFieldChange(
    event: Event,
    bookWidgetFieldUpdateType: BookWidgetFieldUpdateTypes
  ) {
    const target = event.target as HTMLInputElement;
    const emitValue: BookWidgetFieldUpdateEvent = {
      data: target.value,
      type: bookWidgetFieldUpdateType
    };

    this.bookWidgetFieldChange.emit(emitValue);
  }

  clearConnectionAirport(flightIndex: number) {
    const emitValue: BookWidgetFieldUpdateEvent = {
      data: {
        airportCode: '',
        airportCity: '',
        flightIndex
      },
      type: BookWidgetFieldUpdateTypes.connectionAirport
    };
    this.bookWidgetFieldChange.emit(emitValue);
  }
}
